(()=>{
 const init=root=>{
  if(root.dataset.tabsReady)return;
  root.dataset.tabsReady='true';
  const tabs=[...root.querySelectorAll('[role="tab"]')];
  const select=tab=>tabs.forEach(item=>{const active=item===tab;item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1;root.querySelector('#'+CSS.escape(item.getAttribute('aria-controls'))).hidden=!active;});
  tabs.forEach((tab,index)=>{
   tab.addEventListener('click',()=>select(tab));
   tab.addEventListener('keydown',event=>{
    let next;
    if(event.key==='ArrowRight')next=(index+1)%tabs.length;
    else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
    else if(event.key==='Home')next=0;
    else if(event.key==='End')next=tabs.length-1;
    else return;
    event.preventDefault();select(tabs[next]);tabs[next].focus();
   });
  });
 };
 document.querySelectorAll('[data-home-pricing]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-home-pricing]').forEach(init));
})();
